import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import Wordmark from "@/components/Logo";
import { scrollToSection } from "@/lib/scroll";

const LINKS = [
  { id: "servicios", label: "Servicios" },
  { id: "zonas", label: "Zonas" },
  { id: "protocolo", label: "Protocolo" },
  { id: "nosotros", label: "Nosotros" },
];

const Nav = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const go = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToSection(id), 400);
    } else {
      scrollToSection(id);
    }
  };
  return (
    <header className="fixed top-0 inset-x-0 z-40 bg-[#151A1F]/85 backdrop-blur-md border-b border-white/10">
      <div className="mx-auto max-w-7xl px-6 sm:px-10 h-[72px] flex items-center justify-between">
        <button
          data-testid="nav-logo-button"
          onClick={() => go("hero")}
          className="flex items-center"
          aria-label="Ir al inicio"
        >
          <Wordmark tone="light" className="text-xl" />
        </button>
        <nav className="hidden lg:flex items-center gap-8" aria-label="Navegación principal">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="font-mono-tech text-xs uppercase tracking-[0.2em] text-[#F6F7F5]/70 hover:text-[#00A651] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta-cotizar"
            onClick={() => go("cotizar")}
            className="bg-[#FFB000] text-[#151A1F] font-display font-semibold text-sm px-5 py-2.5 rounded-full hover:scale-[1.03] transition-transform duration-300"
          >
            Cotizar
          </button>
        </nav>
        <button
          data-testid="nav-menu-toggle"
          className="lg:hidden text-[#F6F7F5]"
          onClick={() => setOpen(!open)}
          aria-label="Abrir menú"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="lg:hidden overflow-hidden border-t border-white/10 bg-[#151A1F]"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`nav-mobile-link-${l.id}`}
                  onClick={() => go(l.id)}
                  className="text-left font-mono-tech text-sm uppercase tracking-[0.2em] text-[#F6F7F5]/80"
                >
                  {l.label}
                </button>
              ))}
              <button
                data-testid="nav-mobile-cta-cotizar"
                onClick={() => go("cotizar")}
                className="bg-[#FFB000] text-[#151A1F] font-display font-semibold text-sm px-5 py-3 rounded-full w-fit"
              >
                Cotizar aplicación
              </button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Nav;
